import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';
import React from 'react';

const SubmitSecureInformationRequestModal = ({
  isShown,
  setShown,
  onSubmit,
  isSubmitting,
}: {
  isShown: boolean;
  setShown: React.Dispatch<React.SetStateAction<boolean>>;
  onSubmit: () => void;
  isSubmitting: boolean;
}) => {
  return (
    <Dialog open={isShown} onOpenChange={setShown}>
      <DialogContent hideCloseIcon={isSubmitting}>
        <DialogHeader>
          <DialogTitle>Confirm Submission</DialogTitle>
        </DialogHeader>
        <div className="p-3xl">
          <p className="txt-medium-regular text-text-secondary">
            Once submitted, the details you have entered cannot be edited.
            Please review your information carefully before proceeding.
          </p>
        </div>
        <DialogFooter className="flex justify-end">
          <div className="grid grid-cols-2 gap-lg">
            <Button
              variant="secondary"
              onClick={() => setShown(false)}
              className="col-span-1"
              fullWidth
            >
              Review
            </Button>
            <Button
              disabled={isSubmitting}
              onClick={onSubmit}
              isLoading={isSubmitting}
              className="col-span-1"
              fullWidth
            >
              <span>Submit</span>
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export { SubmitSecureInformationRequestModal };
